<!--后台获取图片验证码-->
<template>
  <div :style="{'display':otherShowParam ? display : 'none'}" id="picCaptcha">
    <v-text-field
        @input="onCaptchaInputChanged"
        placeholder="请输入图形验证码"
        autocomplete="off"
        v-model="$store.state.picCaptcha"
        :rules = "requiredRule"
        variant="underlined">
      <template v-slot:message>
        <div v-show="!$store.state.picCaptchaError" style="padding-top: 1px;padding-right: 1px;color: #ff5252" ><span class="iconfontFamily" style="font-size: 12px;">&#xe612;</span>&nbsp;验证码不能为空</div>
      </template>
      <template v-slot:append>
        <img @click="getPicCaptcha" :src="picCaptchaSrc" style="height:40px;cursor:pointer;">
      </template>
    </v-text-field>
    <div v-show="$store.state.picCaptchaError" style="margin-top: -18px;color: #ff5252;font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码有误，请重新输入</div>
  </div>

</template>

<script>
export default {
  name: "InputPicCaptcha",
  data(){
    return{
      //验证码行是否显示
      display:"none",

      //验证码检查规范
      requiredRule:[v => !!v || 'E-mail is required'],

      //生成图形验证码
      picCaptchaSrc:"",



    }

  },
  props:{
    phone:{default:""},
    prefix:{default:""},
    otherShowParam:{default:true},   //其他显隐相关参数
  },
  watch:{
    //监听父组件传参的+86和手机号变化
    phone(){
      this.checkShow();
    },
    prefix(){
      this.checkShow();
    },
    otherShowParam(newData, oldData){
      console.log(newData,oldData)
      this.checkShow();
    }
  },
  methods:{
    //获取图形验证码
    getPicCaptcha(){
      let formData = new FormData()
      formData.append('phone',this.phone)
      formData.append('prefix',"+" + this.prefix)
      this.$axios({
        method:"post",
        url:"/userApi/getPhonePicCaptcha",
        data:formData
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.code === 200){
          this.picCaptchaSrc = resultData.data.picture;
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //填写时验证码错误提示隐藏
    onCaptchaInputChanged(){
      this.$store.state.picCaptchaError = false
    },


    //检查是否需要展示验证码行
    checkShow(){
      console.log(this.otherShowParam)
      if((this.prefix === '86' ? this.phone.length === 11 : !!this.phone) && this.otherShowParam){
        console.log(this.otherShowParam)
        //手机号合法，展示
        this.display = "block";
        this.getPicCaptcha();
      }
      else{
        //手机号不合法
        this.display = "none";
        this.$store.state.picCaptcha = "";
        this.$store.state.picCaptchaError = false
      }
    }


  },

  mounted(){
    console.log(this.otherShowParam)
  }


}
</script>

<style scoped>

</style>